import { LocationCategoryDTO } from "src/app/features/locations-map/models/LocationCategoryDTO";
import { PermissionDTO } from "../Permissions/PermissionDTO";
import { ViewDTO } from "../Views/ViewDTO";
import { CustomerConfigurationsDTO } from "../Customers/CustomerConfigurationsDTO";
import { UrlSasDTO } from "../AzureStorage/UrlSasDTO";
import { SystemNotificationDTO } from "../SystemNotification/SystemNotificationDTO";
import { CitronellaUrlSettingsResponse } from "../ExternalAPI/CitronellaUrlSettingsResponse";

  export class OnWebCallbackRequest{
     isRequiredUpdateClientId: boolean;
    }